<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>
<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
// fix css style bug in open el-dialog
::v-deep .el-popup-parent--hidden {
  padding: 0 !important;

  .fixed-header {
    padding-right: 15px;
  }
}

.app-main {
  width: 100%;
  height: calc(100vh - 86px);
  //overflow: hidden;
}
</style>
